import { useReducer, useMemo } from 'react';
import {
  EquipmentCategoryFilterStateParams,
  filterEquipmentData,
} from './Utils';
import { EquipmentCategoryItem } from 'api/equipmentApi';

const initialFilterState: EquipmentCategoryFilterStateParams = {
  filterSectionOpen: false,
  branchIds: [],
  itemNames: [],
  filterClient: [],
};

export type FilterAction =
  | {
      type: 'SET_FIELD';
      field: keyof EquipmentCategoryFilterStateParams;
      value: any;
    }
  | { type: 'RESET' }
  | { type: 'TOGGLE_SECTION' };

function filterReducer(
  state: EquipmentCategoryFilterStateParams,
  action: FilterAction
): EquipmentCategoryFilterStateParams {
  switch (action.type) {
    case 'SET_FIELD':
      return { ...state, [action.field]: action.value };

    case 'RESET':
      return { ...initialFilterState, filterSectionOpen: true };

    case 'TOGGLE_SECTION':
      return {
        ...state,
        filterSectionOpen: !state.filterSectionOpen,
      };

    default:
      return state;
  }
}

export const useEquipmentFilters = (
  equipmentData: EquipmentCategoryItem[] | undefined,
  setFilteredEquipmentData: (data: EquipmentCategoryItem[]) => void
) => {
  const [state, dispatch] = useReducer(filterReducer, initialFilterState);

  const activeFilterCount = useMemo(() => {
    return (
      state.branchIds.length +
      state.filterClient.length +
      state.itemNames.length
    );
  }, [state]);

  const filteredResult = useMemo(() => {
    return filterEquipmentData(equipmentData || [], state);
  }, [equipmentData, state]);

  const applyFilters = () => {
    setFilteredEquipmentData(filteredResult);
    dispatch({ type: 'TOGGLE_SECTION' });
  };

  const resetFilters = () => {
    dispatch({ type: 'RESET' });
  };

  return {
    state,
    dispatch,
    activeFilterCount,
    filteredResult,
    applyFilters,
    resetFilters,
  };
};
